import { getEnvVar } from './env';

export const waitForCachedData = async (supportDataCache, key, ms) =>
  await new Promise((resolve) => {
    const checkForData = setInterval(() => {
      if (supportDataCache[key]) {
        clearInterval(checkForData);
        resolve(supportDataCache[key]);
      }
    }, ms);
  });

export const clearCache = (dataSourceCache) => {
  for (const prop of Object.getOwnPropertyNames(dataSourceCache)) {
    delete dataSourceCache[prop];
  }
};

// appUrl is used for testing
export const setUserCacheKey = (actorCodeWithDomain, appUrl = '') => {
  const adminAppUrl = getEnvVar('REACT_APP_ADMIN_APP_URL') || appUrl;
  const domain = actorCodeWithDomain.toLowerCase().split('@')[1];

  try {
    const appName = adminAppUrl
      .split('://')
      .slice(1)[0]
      .split('/')
      .slice(1)
      .filter((a) => a)
      .join('/');

    localStorage.setItem('userCacheKey', `${appName}@${domain}`);
  } catch {
    localStorage.setItem('userCacheKey', `${adminAppUrl}@${domain}`);
  }
};
